<template>
  <div class="banned-comments-page">
    <el-card shadow="never" class="table-card">
      <div slot="header" class="card-header">
        <div class="title-wrap">
          <span class="title-icon"><i class="el-icon-chat-line-square" /></span>
          <span class="title-text">被封禁的评论</span>
        </div>
        <span class="total-badge">共 {{ total }} 条</span>
      </div>

      <el-table
        v-loading="loading"
        :data="list"
        class="banned-table"
        :header-cell-style="headerStyle"
      >
        <el-table-column label="评论内容" min-width="220" show-overflow-tooltip>
          <template slot-scope="{ row }">
            <span class="comment-content">{{ row.content }}</span>
          </template>
        </el-table-column>
        <el-table-column label="用户" min-width="140">
          <template slot-scope="{ row }">
            <div class="user-cell">
              <div class="user-name">{{ userDisplayName(row) }}</div>
              <div class="user-code">{{ formatUserCode(row.userId) }}</div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="所属作品" min-width="160" show-overflow-tooltip>
          <template slot-scope="{ row }">{{ row.workTitle || `作品${row.workId}` }}</template>
        </el-table-column>
        <el-table-column label="封禁时间" width="130">
          <template slot-scope="{ row }">{{ formatBanDate(row) }}</template>
        </el-table-column>
        <el-table-column label="操作" width="90" fixed="right">
          <template slot-scope="{ row }">
            <el-button type="text" size="small" class="danger" @click="handleDelete(row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        v-if="total > pageSize"
        class="pagination"
        background
        layout="total, prev, pager, next"
        :current-page.sync="page"
        :page-size="pageSize"
        :total="total"
        @current-change="loadList"
      />
    </el-card>
  </div>
</template>

<script>
import { getComments, deleteComment } from '@/api/admin'
import { formatUserCode, formatUserDate } from '@/utils/userFormat'
import listPage from '@/mixins/listPage'

export default {
  name: 'AdminCommentsBanned',
  mixins: [listPage],
  created() {
    this.loadList()
  },
  methods: {
    formatUserCode,
    headerStyle() {
      return {
        background: '#fafafa',
        color: '#606266',
        fontWeight: '600'
      }
    },
    userDisplayName(row) {
      return row.userName || `用户${row.userId}`
    },
    formatBanDate(row) {
      return formatUserDate(row.bannedAt || row.createdAt)
    },
    fetchList(params) {
      return getComments({
        ...params,
        status: 0
      })
    },
    handleDelete(row) {
      this.$confirm('确定删除该被封禁评论？删除后不可恢复。', '删除确认', { type: 'warning' })
        .then(async () => {
          await deleteComment(row.id)
          this.$message.success('已删除')
          this.loadList()
        }).catch(() => {})
    }
  }
}
</script>

<style scoped>
.banned-comments-page {
  padding: 0;
}
.table-card {
  border: none;
  border-radius: 12px;
}
.card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.title-wrap {
  display: flex;
  align-items: center;
  gap: 10px;
}
.title-icon {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: rgba(239, 68, 68, 0.12);
  color: #ef4444;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
}
.title-text {
  font-size: 16px;
  font-weight: 600;
  color: #1e293b;
}
.total-badge {
  display: inline-flex;
  align-items: center;
  padding: 4px 12px;
  border-radius: 999px;
  background: rgba(239, 68, 68, 0.1);
  color: #ef4444;
  font-size: 13px;
  font-weight: 500;
}
.banned-table {
  width: 100%;
}
.banned-table::before {
  display: none;
}
.comment-content {
  color: #334155;
  line-height: 1.5;
}
.user-cell {
  line-height: 1.4;
}
.user-name {
  font-weight: 600;
  color: #1e293b;
}
.user-code {
  margin-top: 2px;
  font-size: 12px;
  color: #94a3b8;
}
.pagination {
  margin-top: 16px;
  text-align: right;
}
.danger {
  color: #ef4444;
}
</style>

<style>
.banned-comments-page .el-table td,
.banned-comments-page .el-table th {
  border-bottom: 1px solid #f1f5f9;
}
.banned-comments-page .el-table--enable-row-hover .el-table__body tr:hover > td {
  background: #f8fafc;
}
.banned-comments-page .el-table__empty-block {
  min-height: 180px;
}
</style>
